import * as lenis from './lenis'

export default el => {
	const btns = document.querySelectorAll(`[aria-controls*="${el.id}"]`);

	btns.forEach(btn => {
		btn.addEventListener('click', () => {
			const status = el.classList.contains('active');

			if (!status) {
				open();
				return;
			}

			close();
		})
	})

	el.addEventListener('click', (e) => {
		var inner = el.querySelector('.dialog__inner');
		if (!inner) inner = el;

		if (
			!inner.contains(e.target)
		) {
			close();
		}	
	})

	const open = () => {
		lenis.destroy();

		if (el.id == 'dialog-nav' || el.id == 'dialog-search') document.querySelector('header.header').classList.add('active');

		if (el.id == 'dialog-search') {
			const input = el.querySelector('.js-searchbar-input');
			if (input) input.focus();
		}

		var content = el.querySelector('.dialog__content');
		if (!content) content = el;

		lenis.init(content);

		// el.style.display = "grid";
		setTimeout(() => {
			content.scrollTo(0, 0);
			el.classList.add('active');
		}, 1)
	}

	const close = () => {
		if (el.id == 'dialog-nav' || el.id == 'dialog-search') document.querySelector('header.header').classList.remove('active');

		lenis.destroy();
		lenis.init();
		el.classList.remove('active');

		setTimeout(() => {
			// el.style.display = "none";
			// el.classList.remove('validation');
		}, 501)
	}
};
